import React from "react";
import { StyledText } from "./CommonStyles";
import useEmpresa from "../../hooks/useEmpresa";

const Text = ({
  size,
  color,
  children,
  isTittle,
  weight,
  margin,
  hoverColor,
}) => {
  const empresa = useEmpresa();

  return (
    <StyledText
      size={size}
      color={!color && isTittle ? empresa?.COLOR_SECUNDARIO : color}
      font={empresa?.LETRA_PRINCIPAL}
      weight={weight}
      margin={margin}
      hoverColor={hoverColor}
    >
      {children}
    </StyledText>
  );
};

export default Text;